import { render, staticRenderFns } from "./RulebookFeedbackTab.vue?vue&type=template&id=e09b73e8&scoped=true&"
import script from "./RulebookFeedbackTab.vue?vue&type=script&lang=js&"
export * from "./RulebookFeedbackTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookFeedbackTab.vue?vue&type=style&index=0&id=e09b73e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09b73e8",
  null
  
)

export default component.exports